class TidioSection extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("[data-open-chat-btn]");
    this.scriptLoaded = false;

    if (this.button) {
      this.button.addEventListener("click", () => this.loadAndOpenChat());
    }
  }

  loadAndOpenChat() {
    const triggerCustomEvent = () => {
      if (window.tidioChatApi) {
        window.tidioChatApi.track("chat_link_clicked");
      }
    };

    const openChat = () => {
      window.tidioChatApi.show();
      window.tidioChatApi.open();
      triggerCustomEvent();
    };

    if (window.tidioChatApi) {
      openChat();
      return;
    }

    if (!this.scriptLoaded) {
      this.scriptLoaded = true;

      const tidioScript = document.createElement("script");
      tidioScript.src =
        "https://code.tidio.co/fgoqknfs9iubc9bknf69qa7wil0fj8dr.js";
      tidioScript.async = true;
      document.body.appendChild(tidioScript);

      document.addEventListener("tidioChat-ready", openChat);
    } else {
      document.addEventListener("tidioChat-ready", openChat);
    }
  }
}

customElements.define("tidio-section", TidioSection);
